"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yn = void 0;
function yn(value) {
    if (value == null) {
        return null;
    }
    value = String(value).trim();
    if (/^(?:y|yes|true|1|on)$/i.test(value)) {
        return true;
    }
    if (/^(?:n|no|false|0|off)$/i.test(value)) {
        return false;
    }
    return null;
}
exports.yn = yn;
//# sourceMappingURL=yn.js.map